module.exports = __webpack_public_path__ + "SPACEC6P.cbfa23bdc8b68423192d.eot";


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/assets/fonts/SPACEC6P.eot
// module id = ../../../../../src/assets/fonts/SPACEC6P.eot
// module chunks = main